// extracted by mini-css-extract-plugin
module.exports = {"image":"pZ","hidden":"p0"};